// extracted by mini-css-extract-plugin
module.exports = {"link":"Link_link___565P","disabled":"Link_disabled__DaJ4N"};